import { SxProps } from '@mui/material'
import { GridEventListener, GridRowSelectionModel } from '@mui/x-data-grid'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

import KanseiDataGrid from 'components/copied/dataGrid'
import { SecurityField } from 'types/securityField'

interface Props {
  securityFields: SecurityField[]
  onChangeChecked: (securityFieldIds: string[]) => void
}

const columns = [
  { field: 'name', headerName: '警備先名', width: 200 },
  { field: 'phone', headerName: '携帯電話', width: 100 },
  { field: 'email', headerName: 'メールアドレス', width: 200 },
]

const securityFieldSettingsURL = (securityFieldId: string) =>
  `/security_field/settings/${securityFieldId}`

export default function SecurityFieldTableComponent(props: Props) {
  const navigate = useNavigate()

  const rows = useMemo(() => {
    return props.securityFields.map((securityField) => ({
      id: securityField.id,
      name: securityField.name,
      phone: securityField.phone,
      email: securityField.email,
    }))
  }, [props.securityFields])

  const handleCellClick: GridEventListener<'cellClick'> = (params, event) => {
    const isCheckbox = params.field === '__check__'
    if (!isCheckbox) {
      // チェックボックスをトグルさせない
      event.stopPropagation()

      navigate(securityFieldSettingsURL(params.id as string))
      return
    }
  }

  const handleChecked = (e: GridRowSelectionModel) => {
    props.onChangeChecked(e as string[])
  }

  return (
    <KanseiDataGrid
      rows={rows as []}
      columns={columns}
      handleChange={handleChecked}
      onCellClick={handleCellClick}
      sx={gridStyle}
      showMenu={true}
    />
  )
}

const gridStyle: SxProps = {
  padding: 0,
  // メモ
  // なぜかdata-gridのスクロールが効いてない
  // 一旦、上から強制的にスタイルを書き換えてスクロールしている
  '& .MuiDataGrid-virtualScroller': {
    overflowY: 'scroll',
  },
}
